module.exports = __webpack_public_path__ + "static/media/paper_thumbnail.e57de61b.png";